import React from "react";
import "../../pages/styles/Productos.css";
import ReactTable from "react-table";
import "react-table/react-table.css";
import matchSorter from "match-sorter";
import ReactExport from "react-data-export";
import moment from "moment";
import { BotonExcel } from "../Plantillas/Botones";
import HistorialComprasPopover from "./HistorialComprasPopover";

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;

class ControlCProductosSucursalesUI extends React.Component {

    constructor(props) {
        super(props);
        const today = new Date();
        const oneWeekAgo = new Date(today.setDate(today.getDate() - 7));
        
        this.state = {
            fechaInicio: moment(oneWeekAgo).format("YYYY-MM-DD"),
            fechaFin: moment(new Date()).format("YYYY-MM-DD"),
            diasProyeccion: props.diasProyeccion || 30,
            historialeCargando: {},
            historialesData: {},
            popoverAbiertoId: null,
            showHelp: false
        };
        
        this.onChangeFechaInicioHandler = this.onChangeFechaInicioHandler.bind(this);
        this.onChangeFechaFinHandler = this.onChangeFechaFinHandler.bind(this);
        this.handleFilterChange = this.handleFilterChange.bind(this);
    }

    componentDidMount() {
        this.handleFilterChange();
    }

    onChangeFechaInicioHandler(e) {
        this.setState({ fechaInicio: e.target.value }, () => {
            this.handleFilterChange();
        });
    }

    onChangeFechaFinHandler(e) {
        this.setState({ fechaFin: e.target.value }, () => {
            this.handleFilterChange();
        });
    }

    handleFilterChange() {
        const { fechaInicio, fechaFin } = this.state;
        if (this.props.onFilterChange) {
            this.props.onFilterChange({ fechaInicio, fechaFin });
        }
    }

    cambiarModoVista = (modo) => {
        if (this.props.onCambiarModoVista) {
            this.props.onCambiarModoVista(modo);
        }
    };

    cambiarDiasProyeccion = (dias) => {
        this.setState({ diasProyeccion: dias }, () => {
            if (this.props.onCambiarDiasProyeccion) {
                this.props.onCambiarDiasProyeccion(dias);
            }
        });
    };

    getDataExportExcel(dataSet, sucursales, modoVista) {
        if (!dataSet || dataSet.length === 0 || !sucursales) return [];

        const columns = [
            { title: `Código`, width: { wpx: 100 } },
            { title: `Nombre`, width: { wpx: 200 } }
        ];

        switch(modoVista) {
            case 'predicciones':
                columns.push(
                    { title: `Stock Actual`, width: { wpx: 100 } },
                    { title: `Demanda Diaria`, width: { wpx: 100 } },
                    { title: `Días Hasta Agotar`, width: { wpx: 100 } },
                    { title: `Necesita Compra`, width: { wpx: 100 } },
                    { title: `Cantidad Recomendada`, width: { wpx: 120 } },
                    { title: `Fecha Recomendada`, width: { wpx: 120 } },
                    { title: `Prioridad`, width: { wpx: 80 } }
                );
                break;
                
            case 'abc':
                columns.push(
                    { title: `Ranking`, width: { wpx: 80 } },
                    { title: `Valor Vendido`, width: { wpx: 120 } },
                    { title: `% Valor`, width: { wpx: 80 } },
                    { title: `% Acumulado`, width: { wpx: 100 } },
                    { title: `Clasificación ABC`, width: { wpx: 100 } },
                    { title: `Frecuencia Revisión`, width: { wpx: 120 } }
                );
                break;
                
            default:
                columns.push({ title: `Cod. Barras`, width: { wpx: 120 } });
                sucursales.forEach((s) => {
                    columns.push({ title: `${s.Nombre} - Stock`, width: { wpx: 100 } });
                    columns.push({ title: `${s.Nombre} - Ventas`, width: { wpx: 100 } });
                    columns.push({ title: `${s.Nombre} - Compras`, width: { wpx: 100 } });
                    columns.push({ title: `${s.Nombre} - Balance`, width: { wpx: 100 } });
                });
        }

        const data = dataSet.map(row => {
            const rowData = [
                { value: row.codigo || "", style: { fill: { patternType: "solid", fgColor: { rgb: "FFFFFF" } } } },
                { value: row.nombre || "", style: { fill: { patternType: "solid", fgColor: { rgb: "FFFFFF" } } } }
            ];

            switch(modoVista) {
                case 'predicciones':
                    rowData.push(
                        { value: row.stockActual || 0, style: { fill: { patternType: "solid", fgColor: { rgb: "E8F5E9" } } } },
                        { value: row.demandaDiariaTotal || 0, style: { fill: { patternType: "solid", fgColor: { rgb: "FFF3E0" } } } },
                        { value: row.diasHastaAgotar || 0, style: { fill: { patternType: "solid", fgColor: { rgb: row.diasHastaAgotar < 10 ? "FFEBEE" : "F3E5F5" } } } },
                        { value: row.necesitaCompra ? "SÍ" : "NO", style: { fill: { patternType: "solid", fgColor: { rgb: row.necesitaCompra ? "FFCDD2" : "C8E6C9" } } } },
                        { value: row.cantidadRecomendada || 0, style: { fill: { patternType: "solid", fgColor: { rgb: "E3F2FD" } } } },
                        { value: row.fechaRecomendadaCompra || "", style: { fill: { patternType: "solid", fgColor: { rgb: "F3E5F5" } } } },
                        { value: row.prioridadCompra || 4, style: { 
                            fill: { patternType: "solid", fgColor: { rgb: 
                                row.prioridadCompra === 1 ? "FFCDD2" : 
                                row.prioridadCompra === 2 ? "FFECB3" : 
                                row.prioridadCompra === 3 ? "C8E6C9" : "E0E0E0" 
                            } },
                            font: { bold: true }
                        } }
                    );
                    break;
                    
                case 'abc':
                    rowData.push(
                        { value: row.ranking || 0, style: { fill: { patternType: "solid", fgColor: { rgb: "F3E5F5" } } } },
                        { value: `$${parseFloat(row.valorTotalVendido || 0).toFixed(2)}`, style: { fill: { patternType: "solid", fgColor: { rgb: "C8E6C9" } } } },
                        { value: `${row.porcentajeValor || 0}%`, style: { fill: { patternType: "solid", fgColor: { rgb: "E3F2FD" } } } },
                        { value: `${row.porcentajeAcumulado || 0}%`, style: { fill: { patternType: "solid", fgColor: { rgb: "FFF3E0" } } } },
                        { value: row.clasificacionABC || "", style: { 
                            fill: { patternType: "solid", fgColor: { rgb: 
                                row.clasificacionABC === 'A' ? "FFCDD2" : 
                                row.clasificacionABC === 'B' ? "FFECB3" : "C8E6C9" 
                            } },
                            font: { bold: true, color: { rgb: 
                                row.clasificacionABC === 'A' ? "B71C1C" : 
                                row.clasificacionABC === 'B' ? "F57C00" : "1B5E20" 
                            } }
                        } },
                        { value: row.estrategiaCompra?.frecuenciaRevision || "", style: { fill: { patternType: "solid", fgColor: { rgb: "E1F5FE" } } } }
                    );
                    break;
                    
                default:
                    rowData.push({ value: row.CodigoBarra || "", style: { fill: { patternType: "solid", fgColor: { rgb: "FFFFFF" } } } });
                    sucursales.forEach((s) => {
                        const stock = row[`Sucursal${s.IdSucursal}`] || 0;
                        const ventas = row[`Sucursal${s.IdSucursal}_Cantidad`] || 0;
                        const compras = row[`Sucursal${s.IdSucursal}_CompraCantidad`] || 0;
                        const balance = row[`Sucursal${s.IdSucursal}_Balance`] || stock + compras - ventas;
                        
                        rowData.push({ value: stock, style: { fill: { patternType: "solid", fgColor: { rgb: "E8F5E9" } } } });
                        rowData.push({ value: ventas, style: { fill: { patternType: "solid", fgColor: { rgb: "FFEBEE" } } } });
                        rowData.push({ value: compras, style: { fill: { patternType: "solid", fgColor: { rgb: "E3F2FD" } } } });
                        rowData.push({ 
                            value: balance, 
                            style: { 
                                fill: { patternType: "solid", fgColor: { rgb: balance >= 0 ? "F3E5F5" : "FFCDD2" } },
                                font: { bold: true }
                            } 
                        });
                    });
            }

            return rowData;
        });

        return [{ columns, data }];
    }

    renderHelpContent(modoVista) {
        const comun = (
            <div className="alert alert-light border mt-3 mb-0">
                <strong><i className="fas fa-history mr-1"/>Botón Historial:</strong> La primera columna de la tabla tiene
                un botón <i className="fas fa-history"/> por cada producto. Al hacer clic se abre un popover
                con las últimas 3 compras: proveedor, documento, fecha, cantidad, precio y total.
                Se cierra haciendo clic fuera o en el botón cerrar.
            </div>
        );

        switch (modoVista) {
            case 'stock':
                return (
                    <>
                        <div className="alert alert-secondary">
                            <i className="fas fa-info-circle mr-2"/>
                            Muestra el <strong>inventario actual</strong> de todos los productos organizados por sucursal,
                            junto con las ventas y compras del período y el balance resultante.
                        </div>

                        <h6 className="font-weight-bold text-success"><i className="fas fa-calendar-alt mr-2"/>Filtros de Fecha</h6>
                        <p>Usa los campos <strong>Desde</strong> y <strong>Hasta</strong> para definir el período de análisis.
                        Cada cambio de fecha lanza automáticamente una nueva consulta al servidor.</p>

                        <h6 className="font-weight-bold text-success"><i className="fas fa-table mr-2"/>Columnas de la Tabla</h6>
                        <p>Además de código y nombre, por <strong>cada sucursal</strong> verás cuatro columnas:</p>
                        <ul>
                            <li><strong className="text-primary">Stock (azul):</strong> unidades actuales en almacén.</li>
                            <li><strong className="text-success">Ventas (verde):</strong> unidades vendidas en el período.</li>
                            <li><strong className="text-info">Compras (celeste):</strong> unidades ingresadas por compras.</li>
                            <li><strong>Balance (morado/rojo):</strong> resultado de Stock + Compras − Ventas. Positivo en morado, negativo en rojo.</li>
                        </ul>

                        <h6 className="font-weight-bold text-success"><i className="fas fa-lightbulb mr-2"/>Cuándo usarlo</h6>
                        <p>Ideal para hacer el conteo rápido de inventario, verificar si un producto tiene stock en una sucursal específica
                        o comparar el movimiento entre sucursales.</p>

                        <div className="alert alert-warning">
                            <i className="fas fa-exclamation-triangle mr-2"/>Si el balance aparece en <strong className="text-danger">rojo</strong> indica
                            que se registraron más salidas que ingresos en el período, lo que puede señalar un error de registro o
                            stock negativo.
                        </div>
                        {comun}
                    </>
                );

            case 'balance':
                return (
                    <>
                        <div className="alert alert-info">
                            <i className="fas fa-info-circle mr-2"/>
                            Muestra cómo ha <strong>evolucionado cada producto</strong> durante el período seleccionado,
                            combinando el stock actual con los movimientos de ventas y compras.
                        </div>

                        <h6 className="font-weight-bold text-success"><i className="fas fa-calendar-alt mr-2"/>Importancia del Período</h6>
                        <p>A diferencia del modo Stock, en Balance <strong>el rango de fechas es obligatorio</strong> para que los cálculos
                        tengan sentido. Sin fechas el sistema muestra los datos de stock base sin los cálculos de evolución.</p>

                        <h6 className="font-weight-bold text-success"><i className="fas fa-table mr-2"/>Columnas de la Tabla</h6>
                        <p>Por cada sucursal se muestran las mismas cuatro columnas del modo Stock pero calculadas sobre el período elegido:</p>
                        <ul>
                            <li><strong className="text-primary">Stock:</strong> inventario al cierre del período.</li>
                            <li><strong className="text-success">Ventas:</strong> total de unidades salidas por ventas en el período.</li>
                            <li><strong className="text-info">Compras:</strong> total de unidades entradas por compras en el período.</li>
                            <li><strong>Balance:</strong> cálculo dinámico que refleja la variación neta.</li>
                        </ul>

                        <h6 className="font-weight-bold text-success"><i className="fas fa-lightbulb mr-2"/>Cuándo usarlo</h6>
                        <p>Perfecto para cierres de mes, auditorías de inventario o para entender por qué el stock de un producto
                        cambió en un período específico.</p>
                        {comun}
                    </>
                );

            case 'predicciones':
                return (
                    <>
                        <div className="alert alert-primary">
                            <i className="fas fa-chart-line mr-2"/>
                            Usa el historial de ventas del período seleccionado para <strong>proyectar cuándo se agotarán
                            los productos</strong> y recomendar fechas y cantidades de compra.
                        </div>

                        <h6 className="font-weight-bold text-success"><i className="fas fa-sliders-h mr-2"/>Days de Proyección</h6>
                        <p>El selector que aparece junto a los botones define el horizonte de análisis.
                        Por ejemplo, seleccionar <strong>30 días</strong> indica al sistema que identifique los productos
                        que se agotarán dentro de los próximos 30 días.</p>

                        <h6 className="font-weight-bold text-success"><i className="fas fa-table mr-2"/>Columnas de la Tabla</h6>
                        <ul>
                            <li><strong className="text-primary">Stock Actual:</strong> unidades disponibles ahora mismo.</li>
                            <li><strong className="text-info">Demanda Diaria:</strong> promedio de unidades vendidas por día en el período.</li>
                            <li><strong>Días Hasta Agotar:</strong>
                                <span className="text-danger"> rojo &lt;7 días</span>,
                                <span className="text-warning"> amarillo &lt;14</span>,
                                <span className="text-success"> verde &lt;30</span>,
                                gris si hay suficiente stock.
                            </li>
                            <li><strong>Necesita Compra:</strong> <span className="badge badge-danger">SÍ</span> o <span className="badge badge-success">NO</span> según si el stock alcanza para el horizonte de proyección.</li>
                            <li><strong className="text-success">Cantidad Recomendada:</strong> unidades sugeridas para cubrir la demanda proyectada.</li>
                            <li><strong>Fecha Recomendada:</strong> día sugerido para realizar la compra antes de que se agote.</li>
                            <li><strong>Prioridad:</strong>
                                <span className="badge badge-danger ml-1">ALTA</span>
                                <span className="badge badge-warning ml-1">MEDIA</span>
                                <span className="badge badge-info ml-1">BAJA</span>
                                <span className="badge badge-secondary ml-1">NINGUNA</span>
                            </li>
                        </ul>

                        <h6 className="font-weight-bold text-success"><i className="fas fa-exclamation-circle mr-2"/>Panel Informativo</h6>
                        <p>Encima de la tabla aparece un panel naranja que muestra de un vistazo cuántos productos
                        <strong> necesitan compra</strong> y cuántos son <strong>críticos</strong> (prioridad 1).</p>

                        <h6 className="font-weight-bold text-success"><i className="fas fa-lightbulb mr-2"/>Cuándo usarlo</h6>
                        <p>Antes de hacer un pedido a proveedores: el sistema te dice exactamente qué comprar, cuánto y cuándo.
                        Ordena la tabla por <em>Prioridad</em> para atender primero los productos críticos.</p>
                        {comun}
                    </>
                );

            case 'abc':
                return (
                    <>
                        <div className="alert alert-danger" style={{backgroundColor:'#fde8e8'}}>
                            <i className="fas fa-sort-amount-down mr-2"/>
                            Clasifica tus productos en tres categorías según su <strong>valor de ventas</strong> en el período
                            para ayudarte a priorizar el control y las compras.
                        </div>

                        <h6 className="font-weight-bold text-success"><i className="fas fa-info-circle mr-2"/>Metodología ABC</h6>
                        <ul>
                            <li><span className="badge badge-danger">Clase A</span> — El <strong>20% de productos</strong> que generan el <strong>80% del valor de ventas</strong>. Require control estricto y Stock de seguridad alto.</li>
                            <li><span className="badge badge-warning">Clase B</span> — Productos intermedios que representan el <strong>15% del valor</strong>. Control moderado.</li>
                            <li><span className="badge badge-success">Clase C</span> — El mayor número de productos pero solo el <strong>5% del valor</strong>. Control simple y pedidos menos frecuentes.</li>
                        </ul>

                        <h6 className="font-weight-bold text-success"><i className="fas fa-table mr-2"/>Columnas de la Tabla</h6>
                        <ul>
                            <li><strong className="text-primary">#Ranking:</strong> posición del producto por valor de ventas.</li>
                            <li><strong className="text-success">Valor Vendido:</strong> monto total en soles vendido en el período.</li>
                            <li><strong className="text-info">% Valor:</strong> porcentaje que representa este producto sobre el total.</li>
                            <li><strong>% Acumulado:</strong> suma acumulada hasta este producto, útil para ver el corte A/B/C.</li>
                            <li><strong>Clasificación:</strong> etiqueta <span className="badge badge-danger">A</span>, <span className="badge badge-warning">B</span> o <span className="badge badge-success">C</span>.</li>
                            <li><strong>Estrategia de Compra:</strong> sugerencia de frecuencia y cantidad de reposición según la clase.</li>
                        </ul>

                        <h6 className="font-weight-bold text-success"><i className="fas fa-info-circle mr-2"/>Panel Informativo</h6>
                        <p>Encima de la tabla aparece un resumen con la cantidad de productos en cada clase y el valor total del período.</p>

                        <h6 className="font-weight-bold text-success"><i className="fas fa-lightbulb mr-2"/>Cuándo usarlo</h6>
                        <p>Cuando necesitas decidir <em>¿a qué productos prestarles más atención?</em> Los productos A
                        deben tener stock de seguridad alto y revisión semanal. Los C pueden manejarse con
                        reposición puntual y menor frecuencia.</p>
                        {comun}
                    </>
                );

            default:
                return null;
        }
    }

    generarNombreArchivo(modoVista) {
        const { fechaInicio, fechaFin } = this.state;
        const fecha = moment().format('YYYYMMDD_HHmm');
        
        const nombres = {
            'stock': 'Stock',
            'balance': 'Balance',
            'predicciones': 'Predicciones_Compra',
            'abc': 'Analisis_ABC'
        };
        
        const nombreBase = nombres[modoVista] || 'Reporte';
        
        if (fechaInicio && fechaFin) {
            return `${nombreBase}_${fechaInicio}_al_${fechaFin}_${fecha}`;
        }
        return `${nombreBase}_${fecha}`;
    }

    renderPanelInformacion(modoVista, analisisExtra, data) {
        const { fechaInicio, fechaFin, diasProyeccion } = this.state;
        const tieneFechas = fechaInicio && fechaFin;
        
        switch(modoVista) {
            case 'predicciones':
                const necesitaCompra = data.filter(p => p.necesitaCompra).length;
                const criticos = data.filter(p => p.prioridadCompra === 1).length;
                
                return (
                    <div className="alert alert-warning mb-3">
                        <div className="row">
                            <div className="col-md-3">
                                <strong>Proyección:</strong> {diasProyeccion} días
                            </div>
                            <div className="col-md-3">
                                <strong>Necesitan compra:</strong> <span className="badge badge-danger">{necesitaCompra}</span>
                            </div>
                            <div className="col-md-3">
                                <strong>Críticos:</strong> <span className="badge badge-danger">{criticos}</span>
                            </div>
                            <div className="col-md-3">
                                <strong>Productos:</strong> {data.length}
                            </div>
                        </div>
                        {tieneFechas && (
                            <div className="row mt-2">
                                <div className="col-md-12">
                                    <small>
                                        <strong>Análisis basado en:</strong> Período {fechaInicio} al {fechaFin}
                                    </small>
                                </div>
                            </div>
                        )}
                    </div>
                );
                
            case 'abc':
                return (
                    <div className="alert alert-info mb-3">
                        <div className="row">
                            <div className="col-md-3">
                                <strong>Productos A:</strong> <span className="badge badge-danger">{analisisExtra?.productosA || 0}</span>
                            </div>
                            <div className="col-md-3">
                                <strong>Productos B:</strong> <span className="badge badge-warning">{analisisExtra?.productosB || 0}</span>
                            </div>
                            <div className="col-md-3">
                                <strong>Productos C:</strong> <span className="badge badge-success">{analisisExtra?.productosC || 0}</span>
                            </div>
                            <div className="col-md-3">
                                <strong>Total Valor:</strong> S/. {parseFloat(analisisExtra?.totalValor || 0).toFixed(2)}
                            </div>
                        </div>
                        <div className="row mt-2">
                            <div className="col-md-12">
                                <small>
                                    <strong>Clasificación ABC:</strong> Productos A (alta prioridad 80%), B (media 15%), C (baja 5%)
                                </small>
                            </div>
                        </div>
                    </div>
                );
                
            default:
                return (
                    <div className={`alert mb-3 ${tieneFechas ? 'alert-info' : 'alert-warning'}`}>
                        <div className="row">
                            <div className="col-md-4">
                                <strong>Período:</strong> {tieneFechas ? `${fechaInicio} al ${fechaFin}` : 'Sin filtro de fecha'}
                            </div>
                            <div className="col-md-4">
                                <strong>Sucursales:</strong> {this.props.sucursales?.length || 0}
                            </div>
                            <div className="col-md-4">
                                <strong>Productos:</strong> {data.length}
                            </div>
                        </div>
                        {tieneFechas && modoVista === 'balance' && (
                            <div className="row mt-2">
                                <div className="col-md-12">
                                    <small>
                                        <strong>Mostrando:</strong> Stock actual + Ventas del período + Compras del período + Balance
                                    </small>
                                </div>
                            </div>
                        )}
                    </div>
                );
        }
    }

    renderColumnas(modoVista, sucursales) {
        const columnasBase = [
            {
                Header: "Historial",
                id: "historial",
                width: 100,
                sortable: false,
                filterable: false,
                Cell: props => {

                    const producto = props.original;
                    const productoId = producto.IdProducto || producto.id || producto.codigo;
                    const productoNombre = producto.nombre || producto.Nombre || '';
                    const productoCodigo = producto.codigo || producto.Codigo || '';

                    if (!productoId) return null;
                    
                    return (
                        <HistorialComprasPopover
                            productoId={productoId}
                            productoNombre={productoNombre}
                            productoCodigo={productoCodigo}
                            servicioHistorial={this.props.historialService}
                            className="btn-sm"
                            onToggle={(productoId, abierto) => {
                                if (abierto) {
                                    
                                }
                            }}
                        />
                    );
                }
            },
            {
                Header: "Código",
                id: "codigo",
                width: 100,
                accessor: d => d.codigo,
                filterMethod: (filter, rows) => matchSorter(rows, filter.value, { keys: ["codigo"] }),
                filterAll: true
            },
            {
                Header: "Nombre",
                id: "nombre",
                width: 250,
                accessor: d => d.nombre,
                filterMethod: (filter, rows) => matchSorter(rows, filter.value, { keys: ["nombre"] }),
                filterAll: true
            }
        ];

        switch(modoVista) {
            case 'predicciones':
                return [
                    ...columnasBase,
                    {
                        Header: "Stock Actual",
                        id: "stockActual",
                        width: 100,
                        accessor: d => d.stockActual || 0,
                        Cell: props => <span className="text-primary font-weight-bold">{props.value}</span>
                    },
                    {
                        Header: "Demanda Diaria",
                        id: "demandaDiariaTotal",
                        width: 100,
                        accessor: d => parseFloat(d.demandaDiariaTotal || 0).toFixed(2),
                        Cell: props => <span className="text-info">{props.value}</span>
                    },
                    {
                        Header: "Días Hasta Agotar",
                        id: "diasHastaAgotar",
                        width: 120,
                        accessor: d => d.diasHastaAgotar || 0,
                        Cell: props => {
                            const value = props.value;
                            let className = "font-weight-bold ";
                            
                            if (value < 7) className += "text-danger";
                            else if (value < 14) className += "text-warning";
                            else if (value < 30) className += "text-success";
                            else className += "text-secondary";
                            
                            return <span className={className}>{value} días</span>;
                        }
                    },
                    {
                        Header: "Necesita Compra",
                        id: "necesitaCompra",
                        width: 120,
                        accessor: d => d.necesitaCompra ? "SÍ" : "NO",
                        Cell: props => {
                            const necesita = props.value === "SÍ";
                            return (
                                <span className={`badge ${necesita ? 'badge-danger' : 'badge-success'}`}>
                                    {props.value}
                                </span>
                            );
                        }
                    },
                    {
                        Header: "Cantidad Recomendada",
                        id: "cantidadRecomendada",
                        width: 140,
                        accessor: d => d.cantidadRecomendada || 0,
                        Cell: props => {
                            const value = props.value;
                            if (value > 0) {
                                return <span className="text-success font-weight-bold">{value}</span>;
                            }
                            return <span className="text-secondary">-</span>;
                        }
                    },
                    {
                        Header: "Fecha Recomendada",
                        id: "fechaRecomendadaCompra",
                        width: 140,
                        accessor: d => d.fechaRecomendadaCompra || "-",
                        Cell: props => {
                            const fecha = props.value;
                            if (fecha !== "-") {
                                const hoy = new Date();
                                const fechaRec = new Date(fecha);
                                const diasDiff = Math.ceil((fechaRec - hoy) / (1000 * 60 * 60 * 24));
                                
                                let className = "";
                                if (diasDiff < 7) className = "text-danger font-weight-bold";
                                else if (diasDiff < 14) className = "text-warning";
                                else className = "text-success";
                                
                                return <span className={className}>{fecha}</span>;
                            }
                            return <span className="text-secondary">-</span>;
                        }
                    },
                    {
                        Header: "Prioridad",
                        id: "prioridadCompra",
                        width: 100,
                        accessor: d => d.prioridadCompra || 4,
                        Cell: props => {
                            const prioridad = props.value;
                            const textos = ["", "ALTA", "MEDIA", "BAJA", "NINGUNA"];
                            const clases = ["", "badge-danger", "badge-warning", "badge-info", "badge-secondary"];
                            
                            return (
                                <span className={`badge ${clases[prioridad] || 'badge-secondary'}`}>
                                    {textos[prioridad] || "NINGUNA"}
                                </span>
                            );
                        }
                    }
                ];
                
            case 'abc':
                return [
                    ...columnasBase,
                    {
                        Header: "Ranking",
                        id: "ranking",
                        width: 80,
                        accessor: d => d.ranking || 0,
                        Cell: props => <span className="text-primary font-weight-bold">#{props.value}</span>
                    },
                    {
                        Header: "Valor Vendido",
                        id: "valorTotalVendido",
                        width: 120,
                        accessor: d => `S/. ${parseFloat(d.valorTotalVendido || 0).toFixed(2)}`,
                        Cell: props => <span className="text-success font-weight-bold">{props.value}</span>
                    },
                    {
                        Header: "% Valor",
                        id: "porcentajeValor",
                        width: 80,
                        accessor: d => `${d.porcentajeValor || 0}%`,
                        Cell: props => <span className="text-info">{props.value}</span>
                    },
                    {
                        Header: "% Acumulado",
                        id: "porcentajeAcumulado",
                        width: 100,
                        accessor: d => `${d.porcentajeAcumulado || 0}%`,
                        Cell: props => <span className="text-secondary">{props.value}</span>
                    },
                    {
                        Header: "Clasificación",
                        id: "clasificacionABC",
                        width: 100,
                        accessor: d => d.clasificacionABC || "",
                        Cell: props => {
                            const clasificacion = props.value;
                            const colores = {
                                'A': 'danger',
                                'B': 'warning',
                                'C': 'success'
                            };
                            
                            return (
                                <span className={`badge badge-${colores[clasificacion] || 'secondary'} font-weight-bold`}>
                                    {clasificacion}
                                </span>
                            );
                        }
                    },
                    {
                        Header: "Estrategia Compra",
                        id: "estrategiaCompra",
                        width: 200,
                        accessor: d => d.estrategiaCompra?.tipo || "",
                        Cell: props => <span className="text-dark">{props.value}</span>
                    }
                ];
                
            default:
                const columnasNormales = [...columnasBase];
                
                if (modoVista !== 'predicciones' && modoVista !== 'abc') {
                    columnasNormales.push({
                        Header: "Cod. Barras",
                        id: "CodigoBarra",
                        width: 120,
                        accessor: d => d.CodigoBarra || "",
                        filterMethod: (filter, rows) => matchSorter(rows, filter.value, { keys: ["CodigoBarra"] }),
                        filterAll: true
                    });
                }
                
                if (sucursales && sucursales.length > 0 && modoVista !== 'predicciones' && modoVista !== 'abc') {
                    sucursales.forEach((s) => {
                        columnasNormales.push(
                            {
                                Header: `Stock - ${s.Nombre}`,
                                id: `stock_${s.IdSucursal}`,
                                width: 170,
                                accessor: d => d[`Sucursal${s.IdSucursal}`] || 0,
                                Cell: props => <span className="text-primary font-weight-bold">{props.value}</span>,
                                className: "text-center"
                            },
                            {
                                Header: `Ventas - ${s.Nombre}`,
                                id: `ventas_${s.IdSucursal}`,
                                width: 170,
                                accessor: d => d[`Sucursal${s.IdSucursal}_Cantidad`] || 0,
                                Cell: props => <span className="text-success">{props.value}</span>,
                                className: "text-center"
                            },
                            {
                                Header: `Compras - ${s.Nombre}`,
                                id: `compras_${s.IdSucursal}`,
                                width: 170,
                                accessor: d => d[`Sucursal${s.IdSucursal}_CompraCantidad`] || 0,
                                Cell: props => <span className="text-info">{props.value}</span>,
                                className: "text-center"
                            },
                            {
                                Header: `Balance - ${s.Nombre}`,
                                id: `balance_${s.IdSucursal}`,
                                width: 170,
                                accessor: d => {
                                    const stock = d[`Sucursal${s.IdSucursal}`] || 0;
                                    const ventas = d[`Sucursal${s.IdSucursal}_Cantidad`] || 0;
                                    const compras = d[`Sucursal${s.IdSucursal}_CompraCantidad`] || 0;
                                    const balanceCalculado = d[`Sucursal${s.IdSucursal}_Balance`] || stock + compras - ventas;
                                    return balanceCalculado;
                                },
                                Cell: props => {
                                    const value = props.value || 0;
                                    const className = value >= 0 ? "text-dark font-weight-bold" : "text-danger font-weight-bold";
                                    return <span className={className}>{value}</span>;
                                },
                                className: "text-center"
                            }
                        );
                    });
                }
                
                return columnasNormales;
        }
    }

    render() {
        const { tableInfo, data, sucursales = [], periodo, isLoading, modoVista = 'stock', diasProyeccion, analisisExtra } = this.props;
        const { fechaInicio, fechaFin, showHelp } = this.state;
        const dataExport = this.getDataExportExcel(data, sucursales, modoVista);
        const tieneFechas = fechaInicio && fechaFin;

        const styleCalendar = {
            border: "0.5px solid #acacac",
            borderRadius: "25px",
            outline: "none",
            flexBasis: "50%",
            alignSelf: "center"
        };

        const botonesVista = [
    { 
        id: 'stock', 
        label: 'Stock', 
        icon: <span className="mr-1">📋</span>,
        color: 'secondary' 
    },
    { 
        id: 'balance', 
        label: 'Balance', 
        icon: <i className="fas fa-balance-scale mr-1"></i>,
        color: 'info' 
    },
    { 
        id: 'predicciones', 
        label: 'Predicciones', 
        icon: <i className="fas fa-chart-line mr-1"></i>,
        color: 'primary' 
    },
    { 
        id: 'abc', 
        label: 'Análisis ABC', 
        icon: <i className="fas fa-sort-amount-down mr-1"></i>,
        color: 'danger' 
    }
        ];

        return (
            <section className="ventas-fpay-section-vh pt-5">
                <div className="pt-5">
                    <div className="justify-content-center contenedor-fecha-fpay caja-fondo-blanco-m-2">
                        <span className="align-self-center letra-fecha-fpay">Desde: </span>
                        <input
                            type="date"
                            onChange={this.onChangeFechaInicioHandler}
                            value={fechaInicio}
                            className="input__linea mr-1 pl-2 mt-3 mb-3 linea-fecha-fpay"
                            style={styleCalendar}
                        />
                        <span className="align-self-center letra-fecha-fpay">Hasta: </span>
                        <input
                            type="date"
                            onChange={this.onChangeFechaFinHandler}
                            value={fechaFin}
                            className="input__linea mr-1 pl-2 mt-3 mb-3 linea-fecha-fpay"
                            style={styleCalendar}
                        />
                    </div>
                </div>
                <div className="container">
                    <div className="row mb-3">
                        <div className="col-md-8">
                            <div className="btn-group btn-group-toggle" data-toggle="buttons">
                                {botonesVista.map(boton => (
                                    <label 
                                        key={boton.id}
                                        className={`btn btn-outline-${boton.color} ${modoVista === boton.id ? 'active' : ''}`}
                                        onClick={() => this.cambiarModoVista(boton.id)}
                                    >
                                        {boton.icon} {boton.label}
                                    </label>
                                ))}
                            </div>
                        </div>
                        
                        {modoVista === 'predicciones' && (
                            <div className="col-md-4">
                                <div className="input-group">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text">Proyección:</span>
                                    </div>
                                    <select 
                                        className="form-control"
                                        value={diasProyeccion}
                                        onChange={(e) => this.cambiarDiasProyeccion(parseInt(e.target.value))}
                                    >
                                        <option value="7">7 días</option>
                                        <option value="15">15 días</option>
                                        <option value="30">30 días</option>
                                        <option value="60">60 días</option>
                                        <option value="90">90 días</option>
                                    </select>
                                    <div className="input-group-append">
                                        <span className="input-group-text">días</span>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                    
                    <div className="ProcesarBoton mt-1 mb-3">
                        <div className="container d-flex justify-content-start align-items-center">
                            <button
                                className="btn btn-outline-danger btn-sm mr-2"
                                onClick={() => this.setState({ showHelp: true })}
                                title="Ver guía de uso"
                            >
                                <i className="fas fa-question-circle mr-1"/> HELP
                            </button>
                            {data.length > 0 && (
                                <ExcelFile
                                    element={
                                        <BotonExcel 
                                            type="button" 
                                            title="Exportar a Excel"
                                            className="ml-2"
                                        />
                                    }
                                    filename={this.generarNombreArchivo(modoVista)}
                                >
                                    <ExcelSheet
                                        dataSet={dataExport}
                                        name="Reporte"
                                    />
                                </ExcelFile>
                            )}
                        </div>
                        <div className="clearfix">
                            <span className="badge bg-danger text-white float-end">
                                <i className="fas fa-flask me-1"></i> Versión Beta
                            </span>
                        </div>
                    </div>

                    {data.length > 0 && this.renderPanelInformacion(modoVista, analisisExtra, data)}
                    
                    <ReactTable
                        data={data}
                        pages={tableInfo.pages || 1}
                        loading={tableInfo.isLoading || isLoading}
                        defaultFilterMethod={(filter, row) =>
                            String(row[filter.id]) === filter.value
                        }
                        manual={true}
                        filterable={true}
                        sortable={true}
                        onFetchData={this.props.onFilterProds}
                        columns={[{ columns: this.renderColumnas(modoVista, sucursales) }]}
                        defaultPageSize={10}
                        className="-striped -highlight"
                        previousText="Anterior"
                        nextText="Siguiente"
                        noDataText={tieneFechas 
                            ? "No se encontraron registros para el período seleccionado" 
                            : "No se encontraron productos"
                        }
                        loadingText="Cargando..."
                        ofText="de"
                        rowsText="filas"
                        pageText="Página"
                        pageSizeOptions={[10, 20, 25, 50, 100]}
                        showPagination={data.length > 0}
                        minRows={0}
                    />
                </div>

                {showHelp && (() => {
                    const titulosHelp = {
                        stock: { label: 'Vista Stock — Inventario por Sucursal', icon: 'fas fa-boxes', badge: 'badge-secondary' },
                        balance: { label: 'Vista Balance — Evolución del Período', icon: 'fas fa-balance-scale', badge: 'badge-info' },
                        predicciones: { label: 'Vista Predicciones — Planificación de Compras', icon: 'fas fa-chart-line', badge: 'badge-primary' },
                        abc: { label: 'Vista Análisis ABC — Clasificación por Valor', icon: 'fas fa-sort-amount-down', badge: 'badge-danger' }
                    };
                    const tituloActual = titulosHelp[modoVista] || titulosHelp['stock'];
                    return (
                        <div
                            className="modal fade show"
                            style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)', zIndex: 1050 }}
                            role="dialog"
                            aria-modal="true"
                        >
                            <div className="modal-dialog modal-lg modal-dialog-scrollable" role="document">
                                <div className="modal-content">
                                    <div className="modal-header text-white" style={{ background: '#35605a' }}>
                                        <h5 className="modal-title">
                                            <i className={`${tituloActual.icon} mr-2`}/>
                                            Guía: {tituloActual.label}
                                        </h5>
                                        <button
                                            type="button"
                                            className="close text-white"
                                            onClick={() => this.setState({ showHelp: false })}
                                            aria-label="Cerrar"
                                        >
                                            <span aria-hidden="true">&times;</span>
                                        </button>
                                    </div>
                                    <div className="modal-body">
                                        <div className="mb-3">
                                            <small className="text-muted">Modo activo: </small>
                                            <span className={`badge ${tituloActual.badge} ml-1`}>{modoVista.toUpperCase()}</span>
                                            <small className="text-muted ml-2">Cambia de modo para ver la guía correspondiente.</small>
                                        </div>
                                        {this.renderHelpContent(modoVista)}
                                    </div>
                                    <div className="modal-footer d-flex justify-content-between align-items-center">
                                        <small className="text-muted">Estos modos se complementan. Usa cada uno según tu necesidad.</small>
                                        <button
                                            type="button"
                                            className="btn btn-secondary"
                                            onClick={() => this.setState({ showHelp: false })}
                                        >
                                            Cerrar
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    );
                })()}
            </section>
        );
    }
}

export default ControlCProductosSucursalesUI;